import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import CoinId from './CoinId.json';


var cryptocurrencies = require('cryptocurrencies');
var numeral = require('numeral');

class CapModal extends Component {
 
componentDidMount(){
    this._isMounted = true;
    this.getMarketCap();
    
    }

componentDidUpdate(prevProps, prevState) {
   
    if(prevProps.coinName!==this.props.coinName){

       this.getMarketCap();
    }
}

async getMarketCap(){
   /* this.setState({loading:true});
    let y = await cryptocurrencies[this.props.coinName]*/
    let ID = CoinId.filter(coin => coin.name === this.props.coinName)
    let y = ID[0].ID
    //fetch('https://api.coingecko.com/api/v3/simple/price?ids='+y.replace(/\s+/g, '-').toLowerCase()+'&vs_currencies=usd&include_market_cap=true&include_24hr_change=ture&include_last_updated_at=ture')

    if(y !== undefined){
    fetch('https://api.coingecko.com/api/v3/simple/price?ids='+y+'&vs_currencies=usd&include_market_cap=true&include_24hr_change=ture&include_last_updated_at=ture')
          .then(res => res.json())
          .then((data) => {
            if (this._isMounted && data[y]!== undefined){
            this.setState({marketCap: data[y].usd_market_cap,loading:false},()=>console.log())}
          })
          .catch( setTimeout(()=>this.setState({loading:false}),500))}
          else{
            setTimeout(()=>this.setState({loading:false}),500) 
          };
  }

       
componentWillUnmount(){
  this._isMounted = false;
}


constructor(props,context){
    super(props)
    this.state = {

        hide:this.props.onHide,
        loading:true,
        marketCap:null,
        coinChart:[],
        
    }

  }
  
    render(){

        let news =  ''
        if(this.state.loading){
            news = <div style ={{textAlign:"center"}}>
             
            <h1 className="spin mt-5 large"><i class="fas fa-yin-yang"></i></h1>
            
        </div>
        }
        if(this.state.marketCap !== undefined && !this.state.loading && this.props.name !== undefined){
            news = 
                <div className="news" >
                  <div>
                  <a href={this.props.website} target="blank" className="links"> 
                    <img src={this.props.logo} className="logoCap" alt=''/>
                    </a>
                  </div>
                  
                <div className='header'> 
                <a href={this.props.website} target="blank" className="links"> 
                {this.props.name.toUpperCase()}
                </a>
                </div>
                Market Cap: ${numeral(this.state.marketCap).format('0,0.00')}
                </div>
        }
                        
                        else if(!this.state.loading){
                            news =  <div className="news" >
                            <div>
                              <img src={this.props.logo} className="logoCap" alt=''/>
                            </div>
                             {this.props.name}
                          <div> 
                          <a href={'d'} target="blank" className="links"> 
                     
                          </a>
                          </div>
                          Market Cap: Unknown
                          </div>
                        }
       
    return( 
      
      <Modal
        {...this.props}
        size="md"
        height="200px"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        
      <Modal.Header className="modalpie" closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        <div className="banana3">Market Cap</div>
      </Modal.Title>
      </Modal.Header> 
        
      <Modal.Body> 

        {news}
        <button  className="cancel" title="Cancel" onClick={this.props.onHide}>Close</button>
      </Modal.Body>
            
      

      </Modal>
      )
    }

}

export default CapModal;